import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import Layout from "./layout";
import { fetchAchievementAnimationsForUser } from "../apis/achievementsApi";
import AchievementAnimation from "./achievements/AchievementAnimation";

const PrivateRoute = () => {
  const { isAuthenticated, authenticatedUser, loading } = useAuth();
  const location = useLocation();
  const [pendingAnimations, setPendingAnimations] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const fetchPendingAnimations = async () => {
      setPendingAnimations(await fetchAchievementAnimationsForUser(authenticatedUser));
    };
    fetchPendingAnimations();
  }, [isAuthenticated, authenticatedUser]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading indicator while authentication is being checked
  }

  return isAuthenticated ? (
    <Layout>
      {pendingAnimations.length > 0 && (
        <AchievementAnimation animations={pendingAnimations} onClose={() => setPendingAnimations([])} />
      )}
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;